module.exports = __webpack_public_path__ + "img/home_todo_item4.75ef482e.png";